import { FC, PropsWithChildren } from "react";
import { DisplayBreakpoint } from "@/@types/display";
import { useDisplay } from "@/utils/hooks/display.hooks";

type DisplayBreakpointViewProps = { displayBreakpoint: DisplayBreakpoint };
export const DisplayBreakpointView: FC<PropsWithChildren<DisplayBreakpointViewProps>> = ({
  children,
  displayBreakpoint: db,
}) => {
  const display = useDisplay();
  if (display.breakpoint !== db) return null;
  return children;
};

export const MobileView: FC<PropsWithChildren<Omit<DisplayBreakpointViewProps, "displayBreakpoint">>> = ({
  children,
}) => {
  return <DisplayBreakpointView displayBreakpoint={"mobile"} children={children} />;
};

export const PcView: FC<PropsWithChildren<Omit<DisplayBreakpointViewProps, "displayBreakpoint">>> = ({ children }) => {
  return <DisplayBreakpointView displayBreakpoint={"pc"} children={children} />;
};
